import { Reveal, ChapterTag, SectionTitle } from "./Reveal";

const STEPS = [
  { title: "Konsultasi", desc: "Pahami kebutuhan produk, kapasitas, dan budget Anda." },
  { title: "Survey Lokasi", desc: "Pengukuran dan pengecekan kondisi lokasi pemasangan." },
  { title: "Perhitungan & Desain", desc: "Perhitungan beban pendinginan dan desain tata letak." },
  { title: "Penawaran Harga", desc: "Penawaran transparan sesuai spesifikasi yang disepakati." },
  { title: "Produksi & Persiapan", desc: "Penyiapan panel, mesin, dan material pendukung." },
  { title: "Instalasi", desc: "Pemasangan panel dan sistem refrigeration oleh teknisi." },
  { title: "Testing", desc: "Uji operasional dan penurunan suhu hingga mencapai target." },
  { title: "Serah Terima", desc: "Serah terima unit beserta panduan penggunaan & garansi." },
];

export function Process() {
  return (
    <section id="proses" data-testid="process-section" className="relative py-24 sm:py-32 bg-navy-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="05" label="Proses Kerja" />
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionTitle>Alur Kerja yang <span className="text-ice">Jelas & Terukur</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-steel text-base">Delapan tahap standar dari konsultasi awal hingga unit siap beroperasi.</p>
          </Reveal>
        </div>

        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={0.06 * (i % 4)}>
              <li data-testid={`process-step-${i}`} className="group relative h-full border border-glacier/15 rounded-sm p-6 bg-navy-900/60 hover:border-ice/50 transition-colors duration-300">
                <span className="font-display text-5xl font-bold text-navy-800 group-hover:text-ice/25 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-display text-xl font-semibold uppercase tracking-wide text-frost">{s.title}</h3>
                <p className="mt-2 text-sm text-steel leading-relaxed">{s.desc}</p>
                {i < STEPS.length - 1 && (
                  <span className="hidden lg:block absolute top-10 -right-3 w-6 h-px bg-glacier/30" />
                )}
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
